import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ISiteBoxDocumentConfig } from '@core/entities/SiteBoxDocumentConfig'
import { foldersKeys } from '../../folders'

export const useUpdateSiteBoxConfiguration = (
  options?: UseMutationOptions<
    ISiteBoxDocumentConfig,
    RequestErrorType,
    RequestTypes['updateSiteBoxConfiguration']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...siteBoxDocumentsKeys.updateSiteBoxConfiguration,
    ...options,
    onSuccess: (data: ISiteBoxDocumentConfig, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({ documentId: data.documentId })
          .queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
